import constate from 'constate'
import { useParams } from 'react-router'
import { useGetProbationRecordByIdQuery } from '@/features/probation/probation.api.ts'

export const [ProbationRecordDetailsProvider, useProbationRecordDetails] = constate(() => {
  const { probationRecordId } = useParams() as unknown as { probationRecordId: number }
  const { data, refetch, isFetching, error } = useGetProbationRecordByIdQuery({
    id: probationRecordId,
  }, {
    skip: !probationRecordId,
  })

  return {
    data: data?.details,
    viewerRole: data?.viewerRole,
    refetch,
    isFetching,
    error,
  }
})
